module.exports = ".ontop {\n  z-index: 100000; }\n"